import Vue from 'vue'
import Router from 'vue-router'
// import LoginPage from "./components/Native/Elder/ElderOnboarding/LoginPage";
import ElderHeader from "./components/Native/Elder/ElderDashboard/ElderHeader";
import ElderView from "./components/Native/Elder/ElderDashboard/ElderView";
import Summary from "./components/Native/Elder/ElderDashboard/ElderDashboardBody/Profile/Summary";
import FullInfo from "./components/Native/Elder/ElderDashboard/ElderDashboardBody/Profile/FullInfo";
import TestInfo from "./components/Native/Elder/ElderDashboard/ElderDashboardBody/Profile/TestInfo";
import ApplicantsTable from "./components/Native/Elder/ElderDashboard/ElderDashboardBody/Dashboard/ApplicantsTable";
import DashboardView from "./components/Native/Elder/ElderDashboard/ElderDashboardBody/Dashboard/DashboardView";
import ActivityLog from "./components/Native/Elder/ElderDashboard/ElderDashboardBody/Profile/ActivityLog";
import ConfirmPaymentModal
    from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/Profile/ConfirmPaymentModal";
import ActionsComponent from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/Profile/ActionsComponent";
import RedirectPage from "@/components/Native/Elder/ElderOnboarding/RedirectPage";
import {APPLICANT_DASHBOARD} from "@/services/ApiServices";


Vue.use(Router)

export default new Router({
    mode:'history',
    routes: [
        // {
        //     path: "/",
        //     name: "LoginPage",
        //     component: LoginPage
        // },
        {
            path: '/',
            beforeEnter() {
                window.location.href = APPLICANT_DASHBOARD + '/login';

            }
        },
        {
            path: "/redirect/:userToken",
            name: "RedirectPage",
            component: RedirectPage
        },
        {
            path: "/nav",
            name: "ElderHeader",
            component: ElderHeader
        },

        {
            path: "/table",
            name: "ApplicantsTable",
          component: ApplicantsTable
        },
        {
            path:"/profile/:id",
            name:"ElderView",
            component:ElderView,
            children:[
                {
                    path:"/profile/:id",
                    component: Summary,

                },
                {
                    path:"/full-info",
                    component: FullInfo
                },
                {
                    path: "/test-info",
                    component: TestInfo
                },
                {
                    path:"/activity",
                    component:ActivityLog
                },
                {
                    path:"/actions",
                    component:ActionsComponent
                },
            ]
        },
        {
            path: "/dashboard",
            component: DashboardView,
            children: [
                {
                    path: "/applicants-table",
                    component: ApplicantsTable
                }
            ]
        },
        {
            path: "/confirm-payment-details",
            component: ConfirmPaymentModal
        },



    ]
    },
    {
        path:"/lamp-apply",
        beforeEnter() { location.href='https://apply.semicolon.africa/'}
    },
    {
        path: '/applicant',
        beforeEnter() {
            window.location.href = 'https://apply.semicolon.africa/dashboard'
        }
    }
)
